import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import BlankLayout from './../../layout/blank'
import * as Constants from './../../../application/constants'

const NotFound = ({ onBack }) => {
  return (
    <BlankLayout>
      <Box display="flex" justifyContent="center" p={10}>
        <Paper>
          <Box width={400} p={4}>
            <Typography variant="h1">404</Typography>
            <Typography variant="h6" gutterBottom={true}>Page Not Found</Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom={true}>
              It's looking like you may have taken a wrong turn. You stumbled on to a link that does not seem to exist. Click below to get you back on track.
            </Typography>

            <Box pt={2}>
              <Button onClick={onBack} startIcon={<ArrowBackIcon />} variant="contained" color="primary">Return Home</Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </BlankLayout>
  )
}

export default (props) => {
  const dispatch = useDispatch()

  props = {
    ...props,
    onBack: useCallback(() => dispatch(push(Constants.PATH.HOME)), [dispatch])
  }

  return <NotFound {...props} />
}